<template>
  <span class="badge" :class="badgeClass">
    <font-awesome-icon :icon="iconName" />
    &nbsp;{{ $t(`kycRequest.status.${status}`) }}
  </span>
</template>

<script>
export default {
  props: {
    status: { type: String, required: true },
  },
  computed: {
    badgeClass() {
      return ({
        pending: 'badge-secondary',
        waitingKyc: 'badge-warning',
        kycSubmitted: 'badge-info',
        inReview: 'badge-primary',
        exported: 'badge-success',
        canceled: 'badge-light',
      })[this.status] || 'badge-secondary';
    },
    iconName() {
      return ({
        pending: 'clock',
        waitingKyc: 'hourglass-half',
        kycSubmitted: 'check-circle',
        inReview: 'eye',
        exported: 'file-pdf',
        canceled: 'times-circle',
      })[this.status] || 'circle';
    },
  },
};
</script>
